import React, { useState } from 'react';
import Sidebar from '../../components/navigation/Sidebar';
import QuickActions from '../../components/navigation/QuickActions';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import AppointmentVolumeMetrics from './components/AppointmentVolumeMetrics';
import TreatmentCaseMetrics from './components/TreatmentCaseMetrics';
import PatientSatisfactionMetrics from './components/PatientSatisfactionMetrics';
import RevenueAnalyticsChart from './components/RevenueAnalyticsChart';
import PerformanceAlerts from './components/PerformanceAlerts';

const PracticeAnalyticsDashboard = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [dateRange, setDateRange] = useState('month');
  const [selectedProvider, setSelectedProvider] = useState('all');

  const providers = [
    { id: 'all', name: 'All Providers' },
    { id: 'dr-chen', name: 'Dr. Michael Chen' },
    { id: 'dr-rodriguez', name: 'Dr. Sarah Rodriguez' },
    { id: 'dr-thompson', name: 'Dr. James Thompson' }
  ];

  const handleExportReport = () => {
    console.log('Exporting analytics report...');
  };

  const handleRefreshData = () => {
    console.log('Refreshing dashboard data...');
  };

  return (
    <div className="flex h-screen bg-background overflow-hidden pt-16">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div
        className={`flex-1 flex flex-col overflow-hidden`}
      >
        <header className="bg-card border-b border-border px-4 md:px-6 py-4 flex-shrink-0">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground flex items-center gap-3">
                <Icon name="BarChart3" size={28} className="text-primary" />
                Practice Analytics Dashboard
              </h1>
              <p className="text-sm text-muted-foreground mt-1">
                Comprehensive performance metrics and business intelligence
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="RefreshCw"
                iconPosition="left"
                onClick={handleRefreshData}
              >
                <span className="hidden sm:inline">Refresh</span>
              </Button>
              <Button
                variant="default"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={handleExportReport}
              >
                <span className="hidden sm:inline">Export Report</span>
              </Button>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="max-w-[1600px] mx-auto space-y-6">
            <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-4">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Date Range
                  </label>
                  <div className="flex gap-2">
                    {['day', 'week', 'month', 'quarter', 'year']?.map((range) => (
                      <button
                        key={range}
                        onClick={() => setDateRange(range)}
                        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                          dateRange === range
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-muted text-muted-foreground hover:bg-muted/80'
                        }`}
                      >
                        {range?.charAt(0)?.toUpperCase() + range?.slice(1)}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Provider Filter
                  </label>
                  <select
                    value={selectedProvider}
                    onChange={(e) => setSelectedProvider(e?.target?.value)}
                    className="w-full px-3 py-2 bg-background border border-border rounded-md text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    {providers?.map((provider) => (
                      <option key={provider?.id} value={provider?.id}>
                        {provider?.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <PerformanceAlerts />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <AppointmentVolumeMetrics dateRange={dateRange} provider={selectedProvider} />
              <TreatmentCaseMetrics dateRange={dateRange} provider={selectedProvider} />
            </div>

            <PatientSatisfactionMetrics dateRange={dateRange} provider={selectedProvider} />

            <RevenueAnalyticsChart dateRange={dateRange} provider={selectedProvider} />
          </div>
        </main>

        <QuickActions />
      </div>
    </div>
  );
};

export default PracticeAnalyticsDashboard;